import { StarIcon } from "@heroicons/react/24/solid"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const REVIEW_KEYS = ["testimonial1", "testimonial2", "testimonial3"]
const ROTATE_MS = 3500

export default function ReviewCarousel() {
  const [index, setIndex] = useState(0)
  const { t } = useTranslation()

  useEffect(() => {
    const interval = setInterval(
      () => setIndex((current) => (current + 1) % REVIEW_KEYS.length),
      ROTATE_MS,
    )

    return () => clearInterval(interval)
  }, [])

  const reviewKey = REVIEW_KEYS[index]

  return (
    <div className="w-full">
      <div className="vm-card animate-slide-in-right p-4" key={reviewKey}>
        <div className="flex items-center justify-between">
          <p className="font-semibold text-vm-ink">
            {t(`pages.checkout.trust_element.${reviewKey}Author`)}
          </p>
          <div className="flex">
            {[0, 1, 2, 3, 4].map((star) => (
              <StarIcon className="h-4 w-4 text-vm-yellow" key={star} />
            ))}
          </div>
        </div>
        <p className="mt-2 text-sm leading-relaxed text-vm-muted">
          {t(`pages.checkout.trust_element.${reviewKey}`)}
        </p>
      </div>

      <div className="mt-3 flex justify-center gap-1.5">
        {REVIEW_KEYS.map((key, dotIndex) => (
          <span
            className={`h-1.5 rounded-full transition-all duration-300 ${
              dotIndex === index ? "w-5 bg-vm-primary" : "w-1.5 bg-vm-line"
            }`}
            key={key}
          />
        ))}
      </div>
    </div>
  )
}
